var map = {
	"./clients-01.svg": 871,
	"./clients-02.svg": 9364,
	"./clients-03.svg": 4997,
	"./clients-04.svg": 4586,
	"./clients-05.svg": 2427,
	"./exttoollogo.png": 2733,
	"./feature-tile-icon-01.svg": 4866,
	"./feature-tile-icon-02.svg": 9905,
	"./feature-tile-icon-03.svg": 7664,
	"./feature-tile-icon-04.svg": 7199,
	"./feature-tile-icon-05.svg": 4622,
	"./feature-tile-icon-06.svg": 8797,
	"./features-split-image-01.png": 1305,
	"./features-split-image-02.png": 3122,
	"./features-split-image-03.png": 4251,
	"./features-tabs-icon-01.svg": 5241,
	"./features-tabs-icon-02.svg": 9658,
	"./features-tabs-icon-03.svg": 4923,
	"./features-tabs-icon-04.svg": 212,
	"./features-tabs-image.png": 7741,
	"./hero/Extraction.png": 9563,
	"./hero/Graph.png": 7982,
	"./hero/Masking.png": 7902,
	"./hero/TemplateExtraction.png": 2289,
	"./iStock-849469292.jpg": 7938,
	"./illustration-element-01.svg": 8858,
	"./illustration-section-01.svg": 7005,
	"./illustration-section-02.svg": 9182,
	"./image-placeholder.jpg": 1984,
	"./iocenters-2673328_1920.jpg": 3950,
	"./logo.svg": 3914,
	"./metal-rod-72700_1920.jpg": 8520,
	"./news-image-01.jpg": 6488,
	"./news-image-02.jpg": 3943,
	"./news-image-03.jpg": 8106,
	"./ocrImage1.png": 3231,
	"./ocrRobot.png": 2843,
	"./pithias-tech.png": 7900,
	"./printer-2339136_1920.jpg": 3054,
	"./team-member-01.jpg": 6673,
	"./team-member-02.jpg": 4534,
	"./team-member-03.jpg": 9299,
	"./team-member-04.jpg": 9136,
	"./team-member-05.jpg": 877,
	"./team-member-06.jpg": 3074,
	"./testimonial-image-01.jpg": 8848,
	"./testimonial-image-02.jpg": 2463,
	"./testimonial-image-03.jpg": 4530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;